import { ListingType } from '../../modules/storefront/listingCardCreation/types'

export const STOREFRONT_TAB = {
  BUILDER: {
    key: 'builder',
    label: 'Builder',
    path: 'builder',
  },
  ANALYTICS: {
    key: 'storefront-metrics',
    label: 'Analytics',
    path: 'storefront-metrics',
  },
} as const

export const STOREFRONT_ROUTES = {
  CREATE_BUTTON: '/flyout/storefront/builder/buttons',
  CREATE_LISTING_CARD: '/flyout/storefront/builder/listing-card',
  NAVIGATE_BUTTON: 'builder/buttons',
  NAVIGATE_LISTING_CARD: 'builder/listing-card',
} as const

export const CREATE_OPTION_KEYS = {
  NEW_BUTTON: 'new_button',
  LISTING_CARD: 'listing_card',
  NEW_STOREFRONT: 'new_storefront',
} as const

export const INTEGRATION_MENU_KEYS = {
  DELETE: 'delete-integration',
  EMBED: 'get-embed-code',
} as const

export const CREATE_BUTTON_LABELS = {
  BUTTON: 'Create new button',
  LISTING_CARD: 'Create new listing card',
  STOREFRONT: 'Create new storefront',
  COMING_SOON: 'Coming soon',
} as const

export const EMPTY_STATE_COPY = {
  [ListingType.BUTTON]: {
    ButtonText: 'Create button',
    title: 'Start creating your first Button',
    subText:
      'Add a Buy with AWS button to your website or landing page to let visitors purchase directly through AWS Marketplace — simplifying procurement and boosting conversions.',
  },
  [ListingType.LISTING_CARD]: {
    ButtonText: 'Create listing card',
    title: 'Start creating your first Listing card',
    subText:
      'Display your AWS Marketplace listing directly on your website or landing page to build trust and drive more purchases through your AWS listing.',
  },
  COMING_SOON: {
    ButtonText: undefined,
    title: 'Storefront coming soon',
    subText:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
} as const

export const EMBED_COPY_SUCCESS = 'Embed code successfully copied!'
export const EMBED_COPY_FAILURE =
  'Failed to copy the embed code. Please try again.'

export const WIDGET_PARTNER_SCRIPT_SRC =
  'https://bwa.marketplace.awsstatic.com/assets/partner.js'
export const WIDGET_MODULE_SCRIPT_SRC =
  'https://widgets.labra.io/HypermarketplaceWidget/assets/js/widget.js'
